angular.module('gym.contacts').factory('NewContactService', function() {
  var NewContactService, contact;
  contact = {
    memberships: [],
    member_styles: []
  };
  NewContactService = {
    get: function(params) {
      var initialContact, mobileAppAccessRequest, omittedKeys, relationshipForContact;
      relationshipForContact = params.relationshipForContact;
      mobileAppAccessRequest = params.mobileAppAccessRequest;
      initialContact = {
        memberships: [],
        member_styles: []
      };
      if (!_.isEmpty(relationshipForContact)) {
        omittedKeys = ['created_at', 'dob', 'first_name', 'id', 'links', 'member_number', 'non_attending_contact_status', 'reason_for_data_collection'];
        if (_.isEqual(contact, initialContact)) {
          contact.contact_information = _.omit(relationshipForContact.contact_information, omittedKeys);
        }
      }
      if (!_.isEmpty(mobileAppAccessRequest) && _.isEqual(contact, initialContact)) {
        contact.mobile_app_access_request_id = mobileAppAccessRequest.id;
        contact.contact_information = {
          first_name: mobileAppAccessRequest.contact_first_name,
          last_name: mobileAppAccessRequest.contact_last_name,
          email: mobileAppAccessRequest.email,
          phone_number: mobileAppAccessRequest.contact_phone_number
        };
      }
      return contact;
    },
    set: function(val) {
      return contact = val;
    },
    addFormInstance: function(formName, instance) {
      return contact[formName].push(instance);
    },
    removeFormInstance: function(formName, index) {
      contact[formName].splice(index, 1);
      return contact[formName];
    },
    clear: function() {
      return contact = {
        memberships: [],
        member_styles: []
      };
    }
  };
  return NewContactService;
});
